module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMElEQVR4Ae3gAZAkSZIkSRKLqpm7R0REZmZmVlVVVVV3d3d3d/fMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMdHd3d3dXV1VVVVVmZkZGRIS7m5kKz0xmV3d1d3dPz8zMzMxMovh3sH1c/DvYfmnx72D7tcW/g+33Fv8Otn9L/BvZPg5cFP9Gtt8b+C7xb2T76cCDxb+B7c8GPgtA/CvZfmngr7gC8a9g+8HAbwEP5grEi8j2g4HfAh7MsyFeBLZfGvgp4ME8J8QLYfs48NHARwHHeV6I58P2ceCjgY8CjvOCIdvHgePAg4GXAt4aeGngOP8y/hH+2Tx1P2QgpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/right.png
// module id = Ycnu
// module chunks = 6